import React from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { IFileFields, IMdNoticeDetail } from "../NoticeTypes";
import moment from "moment";
import { useNoticeModel } from "./summaryModel";
import { YhBut } from "@src/components/YhButton";
import { ReceiverEnum } from "@src/types/FmsEnums";
import { EditModeType, ReceiverType } from "@src/types/FmsTypes";
import useNavModel from "@src/model/navModel";
import { useNoticeDetailModel } from "../detail/detailModel";
import FontIcon from "@src/components/YhIcon";
import { globalPrompt } from "@src/components/YhMessage";
import { YhAuth } from "@src/components/auth/YhAuth";



export function DataTable() {
    const {
        dataSource,
        selectedRowKeys,
        pgCfg,
        loadData,
        setSelectedRowKeys,
        setDrawerVisible,
        setEditModel,
        setSelectedRowData,
        setPreviewData,
        cancleNotice,
        readNotice,
        loading,
    } = useNoticeModel();

    const { onLoadUserByOrg } = useNoticeDetailModel();

    const { addNav } = useNavModel()

    const columns: ColumnsType<IMdNoticeDetail> = [
        {
            align: 'center',
            title: '序号',
            width: 60,
            fixed: 'left',
            render: (v, r, i) => i + 1
        },
        {
            align: "center",
            title: '标题',
            width: 150,
            ellipsis: true,
            fixed: 'left',
            dataIndex: 'title',
        },
        {
            align: "center",
            title: '公告类型',
            width: 120,
            dataIndex: 'noticeTypeName',
        },
        {
            align: "center",
            title: '公告内容',
            width: 200,
            ellipsis: true,
            dataIndex: 'content',
            // render: (v) => <div style={{ overflowY: 'hidden', maxHeight: '20px' }} dangerouslySetInnerHTML={{
            //     __html: v
            // }}></div>
        },
        {
            align: "center",
            title: '创建人',
            width: 120,
            dataIndex: 'createUser',
        },
        {
            align: "center",
            title: '修改人',
            width: 120,
            dataIndex: 'updateUser',
        },
        {
            align: "center",
            title: '发布人',
            width: 120,
            dataIndex: 'publishUser',
            render: (v, r) => r.status === 1 ? r.updateUser ?? r.createUser : ''
        },
        {
            align: "center",
            title: '发布单位',
            width: 120,
            dataIndex: 'sourceOrgName',
        },
        {
            align: "center",
            title: '发布范围',
            width: 120,
            dataIndex: 'receiverTypeCode',
            render: (v) => ReceiverEnum[v as ReceiverType]
        },
        {
            align: "center",
            title: '附件',
            width: 150,
            dataIndex: 'attachInfo',
            render: (v) => <div>
                {v.map((item: IFileFields) =>
                    <div className="one-line" title={item.attachName} key={item.id}>
                        {
                            item.fileType.indexOf('image/') !== -1 ? <FontIcon style={{ fontSize: '24px' }} type="icon-tupian2" />
                            : item.attachName.indexOf('.pdf') !== -1 ? <FontIcon style={{ fontSize: '24px' }} type="icon-pdf" />
                                : <FontIcon style={{ fontSize: '24px' }} type="icon-order" />
                        }
                        <span>{item.attachName}</span>
                    </div>
                )}
            </div>
        },
        {
            align: "center",
            title: '时效日期',
            width: 160,
            dataIndex: 'limitTime',
            render: (value) => moment(value).format("YYYY-MM-DD HH:mm:ss")
        },
        {
            align: "center",
            title: '发布状态',
            width: 120,
            dataIndex: 'status',
            render: (v) => v === 0 ? '已保存' : v === 1 ? '已发布' : v === 2 ? '已取消' : ''
        },
        {
            align: "center",
            title: '阅读状态',
            width: 120,
            dataIndex: 'readFlag',
            render: (v, r) => <><span>{r.read}人已读</span><br /><span>{r.unRead}人未读</span></>
        },
        {
            align: "center",
            title: '发布时间',
            width: 160,
            dataIndex: 'pubTime',
            render: (value) => moment(value).format("YYYY-MM-DD HH:mm:ss")
        },
        {
            align: "center",
            title: '操作',
            width: 150,
            dataIndex: 'enable',
            fixed: 'right',
            render: (value, record, index) => {
                return (
                    <div>
                        <YhAuth resCode="portal2.n.ed">
                            <YhBut text="编辑" disabled={record.status === 1} typeName="icon-bianji1" type="green" click={() => onClick('edit', record)}></YhBut>
                        </YhAuth>
                        <YhAuth resCode="portal2.n.ed">
                            <YhBut text="查看" typeName="icon-chakan" type="blue" click={() => onClick('look', record)}></YhBut>
                        </YhAuth>
                        <YhAuth resCode="portal2.n.ed">
                            <YhBut text="预览" typeName="icon-chakan" type="blue" click={() => onClick('preview', record)}></YhBut>
                        </YhAuth>
                        <YhAuth resCode="portal2.n.withdraw">
                            <YhBut text="撤回" disabled={record.status !== 1} typeName="icon-chexiao" type="blue" click={() => onClick('other', record)}></YhBut>
                        </YhAuth>
                    </div>
                )
            }
        },
    ];

    const onClick = (type: EditModeType, data: IMdNoticeDetail) => {
        setSelectedRowData(data)
        setEditModel(type)
        if (type === 'edit' || type === 'look') {
            if (data.receiverTypeCode === 'USER') {
                return onLoadUserByOrg('yh').then(() => addNav("portal-04-01"))
            }
            addNav("portal-04-01")
        } else if (type === 'preview') {
            setDrawerVisible(true)
            setPreviewData(data)
        } else if (type === 'other') {
            globalPrompt('modal', {
                title: "正在进行撤回操作！",
                type: "warning",
                text: "是否确认撤回？",
                cancelShow: true,
                onOk: () => cancleNotice(data.id as string)
            })

        }
    }

    return (
        <Table
            rowKey={record => record.id ?? record.key}
            style={{ cursor: "pointer" }}
            loading={loading}
            // rowSelection={{
            //     type: "radio",
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: IMdNoticeDetail[]) => {
            //         setSelectedRowKeys(selectedRowKeys);
            //     },
            //     selectedRowKeys
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                        }
                    },
                };
            }}
            scroll={{ x: 1500 }} 
        />
    )
}
